module.exports = __webpack_public_path__ + "img/photo.5752df45.png";